import { throwHasRanOutOfMemory } from "./OutOfMemoryError";

export class OutOfMemoryResponseDecorator implements Response {
	constructor(private readonly inner: Response) {}

	async arrayBuffer(): Promise<ArrayBuffer> {
		try {
			return await this.inner.arrayBuffer();
		} catch (e) {
			throwHasRanOutOfMemory(e);
			throw e;
		}
	}

	async blob(): Promise<Blob> {
		try {
			return await this.inner.blob();
		} catch (e) {
			throwHasRanOutOfMemory(e);
			throw e;
		}
	}

	async bytes(): Promise<Uint8Array<ArrayBuffer>> {
		try {
			return await this.inner.bytes();
		} catch (e) {
			throwHasRanOutOfMemory(e);
			throw e;
		}
	}

	async formData(): Promise<FormData> {
		try {
			return await this.inner.formData();
		} catch (e) {
			throwHasRanOutOfMemory(e);
			throw e;
		}
	}

	async json(): Promise<any> {
		try {
			return await this.inner.json();
		} catch (e) {
			throwHasRanOutOfMemory(e);
			throw e;
		}
	}

	async text(): Promise<string> {
		try {
			return await this.inner.text();
		} catch (e) {
			throwHasRanOutOfMemory(e);
			throw e;
		}
	}

	get body(): ReadableStream<Uint8Array<ArrayBuffer>> | null {
		return this.inner.body;
	}

	get bodyUsed(): boolean {
		return this.inner.bodyUsed;
	}

	get headers(): Headers {
		return this.inner.headers;
	}

	get ok(): boolean {
		return this.inner.ok;
	}

	get redirected(): boolean {
		return this.inner.redirected;
	}

	get status(): number {
		return this.inner.status;
	}

	get statusText(): string {
		return this.inner.statusText;
	}

	get type(): ResponseType {
		return this.inner.type;
	}

	get url(): string {
		return this.inner.url;
	}

	clone(): Response {
		return this.inner.clone();
	}
}
